import React from 'react';
import './../index.scss';
const renderErrors = errors => {
	let html = [];
	for (var i in errors) {
		html.push(
			<div className="error" key={i}>
				{errors[i].message}
			</div>
		);
	}
	return (
		<div>
			{html}
		</div>
	);
};

const renderMessages = messages => {
	let html = [];
	for (var i in messages) {
		html.push(
			<div className="message" key={i}>
				{messages[i].message}
			</div>
		);
	}
	return (
		<div>
			{html}
		</div>
	);
};

export { renderErrors, renderMessages };
